<template>
	<a-layout id="components-layout-demo-custom-trigger">
		<a-layout-sider v-model="collapsed" :trigger="null" collapsible>
			<!-- <div class="logo" /> -->
			<a-menu mode="inline" :default-selected-keys="[defaultSelectedKeys]" :defaultOpenKeys="[defaultOpenKeys]" v-model="selectedKeys"
				@click="menuClick">
				<a-sub-menu v-for="(item,index) in routes" v-if="!item.hidden" :key="item.path">
					<span slot="title" class="title-box">
						<a-icon :type="item.icon" />
						<span class="titles">{{item.name}}</span>
						<a-icon v-if="!collapsed" class="icons" type="caret-right" />
					</span>
					<a-menu-item :key="items.path" v-for="(items,indexs) in item.children" v-if="!items.hidden">
						{{items.name}}
					</a-menu-item>
				</a-sub-menu>
			</a-menu>
		</a-layout-sider>
		<a-layout>
			<a-layout-header style="background: #fff; padding: 0">
				<div style="display: flex;align-items: center;justify-content: space-between;padding: 0 24px;">
					<div style="display: flex;">
						<a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'"
							@click="() => (collapsed = !collapsed)" />
						<div style="color: #cc33ff;margin: 0 0 0 10px;line-height: 60px;font-weight: bold;font-size: 15px;" v-if="settlementDate">结算日：{{settlementDate}}</div>
						
						<a-popover v-if="profile.isPrimary>0&&profile.vipLevel!=null&&profile.vipLevel!=undefined">
							<template slot="content">
								<div class="vip-tips">
									<div class="vip-date" v-if="profile.vipExpirationDate">{{!isDatePassed(profile.vipExpirationDate)?`${profile.vipExpirationDate}到期`:`${profile.vipExpirationDate}会员已过期`}}</div>
									<a-divider v-if="profile.vipExpirationDate" />
									<div class="vip-title">基础权益</div>
									<a-divider />
									<div class="v-box" v-if="profile.vipLevel>0">
										<img :src="require('@/assets/vip/v' + profile.vipLevel + '.png')" alt="">
										<div class="num-box">
											<span class="num">￥{{profile.reductionAmount}}</span>
											每单减免金额
										</div>
										<div class="v-text" :class="'v-text' + profile.vipLevel">{{profile.vipLevel==0?'星会员':(profile.vipLevel==1?'银会员':(profile.vipLevel==2?'黄金会员':(profile.vipLevel==3?'铂金会员':(profile.vipLevel==4?'钻石会员':''))))}}减免权益</div>
									</div>
									<div class="tips-box">
										<div class="tips-view" v-for="(item,index) in textList" :key="index">
											<img :src="require('@/assets/vip/tip' + index + '.png')" alt="">
											<div class="tips-text">{{item}}</div>
										</div>
									</div>
									<a-divider style="margin: 15px 0 10px;" />
									<div class="vip-more-btn" @click="vipDetailVisible=true;currentVipTabIndex=profile.vipLevel">
										<span>查看全部会员权益</span>
										<a-icon type="right" />
									</div>
								</div>
							</template>
							<div class="vip-box">
								<img :src="require('@/assets/vip/vip' + profile.vipLevel + '.png')" alt="" />
								<div class="vip-name" :class="'vip-name' + profile.vipLevel">{{profile.vipLevel==0?'星会员':(profile.vipLevel==1?'银会员':(profile.vipLevel==2?'黄金会员':(profile.vipLevel==3?'铂金会员':(profile.vipLevel==4?'钻石会员':''))))}}</div>
								<div class="vip-vipPoints">当前积单：{{profile.vipPoints}}</div>
							</div>
						</a-popover>
					</div>
					<div>
						<a @click="instructionClick" style="padding: 0 10px 0 0;color: #f00;">使用说明</a>
						<a-dropdown>
							<a class="ant-dropdown-link" @click="e => e.preventDefault()">
								{{name}} <a-icon type="down" />
							</a>
							<a-menu slot="overlay">
								<a-menu-item @click="userClick">
									用户信息
								</a-menu-item>
								<a-menu-divider />
								<a-menu-item @click="loginout">
									退出登录
								</a-menu-item>
							</a-menu>
						</a-dropdown>
					</div>
				</div>
			</a-layout-header>
			<a-layout-content
				:style="{ margin: '24px 16px', padding: (showType2?'24px 24px 6px':'0'), background: (showType?'#fff':''), minHeight: (showType2?'auto':'auto') }">
				<router-view class="router-view" />
			</a-layout-content>
		</a-layout>
		<a-modal :title="'用户信息'" :visible="userVisible" @cancel="userVisible=false" cancelText="关闭" @ok="updatePassword"
			okText="修改密码" :maskClosable="false">
			<a-form-model :model="profile" :labelCol="labelCol" :wrapperCol="wrapperCol">
				<a-form-model-item label="账号">
					{{profile.userName}}
				</a-form-model-item>
				<a-form-model-item label="姓名">
					{{profile.fullName}}
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-modal :title="'修改密码'" :visible="passwordVisible" @cancel="handleCancel" cancelText="取消" @ok="passwordSave"
			okText="修改密码" :maskClosable="false">
			<a-form-model ref="passwordForm" :model="passwordForm" :rules="rules">
				<a-form-model-item label="当前密码" prop="password" style="margin: 0">
					<a-input v-model="passwordForm.password" minlength="1" type="password" placeholder="请输入当前账号密码" />
				</a-form-model-item>
				<a-form-model-item label="新密码" prop="newPassword" style="margin: 0">
					<a-input v-model="passwordForm.newPassword" minlength="1" type="password"
						placeholder="新密码与当前密码不能相同" />
				</a-form-model-item>
				<a-form-model-item label="确认密码" prop="newPassword2" style="margin: 0">
					<a-input v-model="passwordForm.newPassword2" minlength="1" type="password"
						placeholder="确认密码跟新密码保持一致" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-modal :title="'使用说明'" :visible="instructionVisible" width="60%" @cancel="instructionVisible = false"
			cancelText="取消" okText="保存" :maskClosable="false" :footer="null">
			<div v-html="instructionForm.content"></div>
		</a-modal>
		<a-modal :title="'会员权益'" :visible="vipDetailVisible" width="60%" @cancel="vipDetailVisible = false"
			cancelText="取消" okText="保存" :maskClosable="false" :footer="null">
			<div class="vip-tabs-container">
				<div class="vip-level-tabs">
					<div 
						v-for="(items,indexs) in vipList" 
						:key="indexs" 
						class="vip-tab-item"
						:class="{ 
							'vip-tab-active': currentVipTabIndex === indexs,
							'vip-tab-now': profile.vipLevel === indexs,
							'vip-tab-locked': items.level > profile.vipLevel
						}"
						@click="currentVipTabIndex=indexs">
						<div class="vip-tab-name">
							{{items.name}}
							<a-icon v-if="items.level > profile.vipLevel" type="lock" class="vip-lock-icon" />
						</div>
					</div>
				</div>
				<div class="vip-content-wrapper">
					<div 
						class="vip-content-area" 
						@touchstart="handleTouchStart"
						@touchmove="handleTouchMove"
						@touchend="handleTouchEnd"
						@mousedown="handleMouseDown"
						@mousemove="handleMouseMove"
						@mouseup="handleMouseUp"
						@mouseleave="handleMouseUp">
						<div 
							class="vip-slider-wrapper" 
							:style="{ transform: `translateX(calc(-${currentVipTabIndex * 100}% + ${slideOffset}px))`, transition: isDragging ? 'none' : 'transform 0.3s ease' }">
							
							<div 
								class="vip-slider-item" 
								v-for="(items,indexs) in vipList" 
								:key="indexs">
								<div class="uplevel" v-if="changeNum(currentVipTabIndex)>0">2026-06-30前再积{{changeNum(currentVipTabIndex)}}单即可升级为{{vipList[currentVipTabIndex].name}}</div>
								<div class="vip-title">基础权益</div>
								<div class="vip-tips" style="margin: 0 auto;">
									<div class="v-box" v-if="items.level>0">
										<img :src="require('@/assets/vip/v' + items.level + '.png')" alt="">
										<div class="num-box">
											<span class="num">￥{{items.price}}</span>
											每单减免金额
										</div>
										<div class="v-text" :class="'v-text' + items.level">{{items.name}}减免权益</div>
									</div>
									
									<div class="tips-box">
										<div class="tips-view" v-for="(item,index) in textList" :key="index">
											<img :src="require('@/assets/vip/tip' + index + '.png')" alt="">
											<div class="tips-text">{{item}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="vip-slide-tip" v-if="vipList.length > 1">
							<span>← 左右滑动查看更多 →</span>
						</div>
					</div>
				</div>
				
			</div>
		</a-modal>
	</a-layout>
</template>

<script>
	import {
		updatePwd
	} from '@/api/user'
	import {
		instructionDetail,
	} from '@/api/order/myOrder'
	import router from '@/router'
	import payOrder from '@/views/payOrder/index'
	export default {
		name: 'Layout',
		data() {
			return {
				collapsed: false,
				userVisible: false,
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 14
				},
				passwordForm: {
					password: '',
					newPassword: '',
					newPassword2: '',
				},
				rules: {
					password: [{
							required: true,
							message: '请输入',
							trigger: 'blur'
						},
						{
							min: 6,
							message: '请输入6位及以上',
							trigger: 'blur'
						}
					],
					newPassword: [{
							required: true,
							message: '请输入',
							trigger: 'blur'
						},
						{
							min: 6,
							message: '请输入6位及以上',
							trigger: 'blur'
						}
					],
					newPassword2: [{
							required: true,
							message: '请输入',
							trigger: 'blur'
						},
						{
							min: 6,
							message: '请输入6位及以上',
							trigger: 'blur'
						}
					],
				},
				passwordVisible: false,
				defaultOpenKeys: '/',
				defaultSelectedKeys: '/project',
				instructionForm: {},
				instructionVisible: false,
				showType: true,
				showType2: true,
				selectedKeys: ['/project'],
				textList: [
					'高效录单',
					'极速返修',
					'智能收货',
					'精准结算',
					'安全下载',
					'专属售后',
					'深度调试',
					'智能分析',
					'高效多号管理',
				],
				vipList: [{
					level: 0,
					name: '星会员',
					num: 0,
					price: 0
				},{
					level: 1,
					name: '银会员',
					num: 200,
					price: 20
				},{
					level: 2,
					name: '黄金会员',
					num: 500,
					price: 30
				},{
					level: 3,
					name: '铂金会员',
					num: 1000,
					price: 40
				},{
					level: 4,
					name: '钻石会员',
					num: 2000,
					price: 50
				}
				],
				vipDetailVisible: false,
				currentVipTabIndex: 0,
				touchStartX: 0,
				touchStartY: 0,
				touchMoveX: 0,
				touchMoveY: 0,
				isDragging: false,
				mouseStartX: 0,
				slideOffset: 0
			}
		},
		computed: {
			routes() {
				return this.$store.state.menu.routes
			},
			profile() {
				return this.$store.state.user.profile
			},
			name() {
				return this.$store.state.user.name
			},
			permissions() {
				return this.$store.state.menu.permissions
			},
			settlementDate() {
			  return this.$store.state.user.settlementDate ? this.$store.state.user.settlementDate : 0
			},
		},
		watch: {
			$route(newValue) {
				if(newValue.path == '/project') {
					this.defaultOpenKeys = '/'
					this.defaultSelectedKeys = '/project'
					this.selectedKeys = [newValue.path]
				}
				if(newValue.path == '/projectStatics') {
					this.showType = false
				}else {
					this.showType = true
				}
				if(newValue.path == '/function') {
					this.showType2 = false
				}else {
					this.showType2 = true
				}
			},
			
		},
		created() {
			
			this.selectedKeys = [this.$route.path]
			if(this.$route.path == '/projectStatics') {
				this.showType = false
			}else {
				this.showType = true
			}
			if(this.$route.path == '/function') {
				this.showType2 = false
			}else {
				this.showType2 = true
			}
			if(this.changeInList('/payOrder')) {
				this.routes[0].children[1].hidden = false
			}else {
				this.routes[0].children[1].hidden = true
			}
			if(this.changeInList('/projectStatics')) {
				this.routes[0].children[2].hidden = false
			}else {
				this.routes[0].children[2].hidden = true
			}
			if(this.changeInList('/functionShowList')) {
				this.routes[0].children[3].hidden = false
			}else {
				this.routes[0].children[3].hidden = true
			}
			for (let x in this.routes) {
				if (this.routes[x].children && this.routes[x].children.length) {
					for (let i in this.routes[x].children) {
						if (this.routes[x].children[i].path == this.$router.currentRoute.path) {
							this.defaultOpenKeys = this.routes[x].path
							this.defaultSelectedKeys = this.routes[x].children[i].path
						}
					}
				}
			}
		},
		methods: {
			isDatePassed(targetDate) {
				const today = new Date();
				const target = new Date(targetDate);
				return today > target;
			},
			changeNum(level) {
				let allnum = this.vipList[level].num
				return allnum - this.profile.vipPoints
			},
			changeInList(name){
				for(let x in this.permissions){
					if(this.permissions[x] == name) {
						return true
					}
				}
				return false
			},
			instructionClick() {
				instructionDetail().then(res => {
					res.data.content = res.data.content.replace(/img src/gi,"img style=\"width:100%;\" src");
					this.instructionForm = res.data
					this.instructionVisible = true
				})
			},
			handleCancel() {
				this.passwordVisible = false
				this.$refs.passwordForm.resetFields()
			},
			userClick() {
				this.userVisible = true
			},
			updatePassword() {
				this.passwordForm = {
					password: '',
					newPassword: '',
					newPassword2: '',
				}
				this.passwordVisible = true
			},
			passwordSave() {
				let that = this
				this.$refs.passwordForm.validate(valid => {
					if (valid) {
						if (this.passwordForm.newPassword != this.passwordForm.newPassword2) {
							this.$message.error("两次密码输入不同")
							return false
						}
						updatePwd(this.passwordForm).then(res => {
							this.$message.success("修改密码成功")
							setTimeout(function() {
								that.loginout()
							}, 1000)
						})
					}
				});
			},
			menuClick(e) {
				this.$router.push(`${e.key}`)
			},
			loginout() {
				this.$store.dispatch('user/logout').then(obj => {
					this.$router.push({
						path: '/login',
					})
				})
			},
			handleTouchStart(e) {
				this.touchStartX = e.touches[0].clientX
				this.touchStartY = e.touches[0].clientY
				this.slideOffset = 0
				this.isDragging = true
			},
			handleTouchMove(e) {
				if (!this.isDragging) return
				this.touchMoveX = e.touches[0].clientX
				this.touchMoveY = e.touches[0].clientY
				
				const deltaX = this.touchMoveX - this.touchStartX
				const deltaY = Math.abs(this.touchMoveY - this.touchStartY)
				
				// 阻止默认滚动行为
				if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) > 10) {
					e.preventDefault()
					
					// 计算偏移量，限制在边界内
					const containerWidth = e.currentTarget.offsetWidth
					const maxOffset = containerWidth * 0.3 // 最大偏移30%
					
					if (deltaX > 0 && this.currentVipTabIndex > 0) {
						// 向右滑动，显示上一个
						this.slideOffset = Math.min(deltaX, maxOffset)
					} else if (deltaX < 0 && this.currentVipTabIndex < this.vipList.length - 1) {
						// 向左滑动，显示下一个
						this.slideOffset = Math.max(deltaX, -maxOffset)
					} else {
						// 边界情况，添加阻尼效果
						this.slideOffset = deltaX * 0.3
					}
				}
			},
			handleTouchEnd(e) {
				if (!this.isDragging) return
				const deltaX = this.touchMoveX - this.touchStartX
				const deltaY = Math.abs(this.touchMoveY - this.touchStartY)
				const minSwipeDistance = 50
				
				// 判断是否为有效的水平滑动
				if (Math.abs(deltaX) > minSwipeDistance && Math.abs(deltaX) > deltaY) {
					if (deltaX > 0) {
						// 向右滑动，切换到上一个
						if (this.currentVipTabIndex > 0) {
							this.currentVipTabIndex--
						}
					} else {
						// 向左滑动，切换到下一个
						if (this.currentVipTabIndex < this.vipList.length - 1) {
							this.currentVipTabIndex++
						}
					}
				}
				
				this.isDragging = false
				this.slideOffset = 0
				this.touchStartX = 0
				this.touchStartY = 0
				this.touchMoveX = 0
				this.touchMoveY = 0
			},
			handleMouseDown(e) {
				this.mouseStartX = e.clientX
				this.slideOffset = 0
				this.isDragging = true
				e.preventDefault()
			},
			handleMouseMove(e) {
				if (!this.isDragging) return
				const deltaX = e.clientX - this.mouseStartX
				const containerWidth = e.currentTarget.offsetWidth
				const maxOffset = containerWidth * 0.3
				
				if (deltaX > 0 && this.currentVipTabIndex > 0) {
					this.slideOffset = Math.min(deltaX, maxOffset)
				} else if (deltaX < 0 && this.currentVipTabIndex < this.vipList.length - 1) {
					this.slideOffset = Math.max(deltaX, -maxOffset)
				} else {
					this.slideOffset = deltaX * 0.3
				}
			},
			handleMouseUp(e) {
				if (!this.isDragging) return
				const deltaX = e.clientX - this.mouseStartX
				const minSwipeDistance = 50
				
				if (Math.abs(deltaX) > minSwipeDistance) {
					if (deltaX > 0) {
						// 向右拖拽，切换到上一个
						if (this.currentVipTabIndex > 0) {
							this.currentVipTabIndex--
						}
					} else {
						// 向左拖拽，切换到下一个
						if (this.currentVipTabIndex < this.vipList.length - 1) {
							this.currentVipTabIndex++
						}
					}
				}
				
				this.isDragging = false
				this.slideOffset = 0
				this.mouseStartX = 0
			},
		}
	}
</script>

<style lang="scss" scoped>
	#components-layout-demo-custom-trigger {
		max-height: 100vh;
		min-height: 100vh;
	}

	#components-layout-demo-custom-trigger .trigger {
		font-size: 18px;
		line-height: 64px;
		padding: 0;
		cursor: pointer;
		transition: color 0.3s;
	}

	#components-layout-demo-custom-trigger .trigger:hover {
		color: #1890ff;
	}

	#components-layout-demo-custom-trigger .logo {
		height: 32px;
		background: none;
		margin: 16px;
	}

	.ant-layout-sider {
		background: #0083E6;
	}

	.ant-layout-sider .ant-menu {
		background: transparent;
		border: none;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu {
		padding: 20px 0;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu .title-box {
		color: #BFBFBF;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu .title-box .titles {
		padding: 10px 0;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu .title-box i {
		font-size: 25px;
		margin: 0;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu .title-box .icons {
		font-size: 14px;
		position: absolute;
		right: 20px;
		bottom: 23px;
		transition: 0.2s all;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu-active .title-box {
		color: #fff;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu-active .title-box .icons,
	.ant-menu-submenu-open .title-box .icons {
		transform: rotate(90deg);

	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu:hover .title-box {
		color: #fff;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu .ant-menu-submenu-arrow {
		display: none;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-submenu .ant-menu-submenu-title {
		height: auto;
	}
	.ant-layout-sider .ant-menu.ant-menu-inline-collapsed /deep/.ant-menu-submenu .ant-menu-submenu-title {
		height: 40px;
	}
	

	.ant-layout-sider .ant-menu /deep/.ant-menu-sub {
		background: #0A64A7;
		// padding: 10px 0;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-sub .ant-menu-item {
		width: 90%;
		margin: 10px auto;
		border-radius: 5px;
		background: transparent;
		color: #fff;
		padding: 0 !important;
		text-align: center;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-sub .ant-menu-item.ant-menu-item-selected {
		background: #0083E6;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-sub .ant-menu-item::after {
		border: none;
	}

	.ant-layout-sider .ant-menu /deep/.ant-menu-sub .ant-menu-item:hover {
		background: #0083E680;

	}
	.vip-tips {
		width: 270px;
		/deep/.ant-divider {
			margin: 0;
		}
		.vip-date {
			line-height: 40px;
			color: #9E9E9E;
			text-align: center;
		}
		.vip-title {
			line-height: 40px;
			color: #000;
			text-align: center;
		}
		.v-box {
			width: 100%;
			margin: 15px 0 5px;
			position: relative;
			img {
				width: 100%;
			}
			.num-box {
				position: absolute;
				width: 100%;
				color: #fff;
				left: 0;
				top: 15px;
				padding: 0 18px;
				font-size: 13px;
				.num {
					font-size: 20px;
					font-weight: bold;
					padding: 0 5px 0 0;
				}
			}
			.v-text {
				position: absolute;
				bottom: 0;
				width: 100%;
				text-align: center;
				line-height: 1.8;
				font-weight: bold;
			}
			.v-text1 {
				color: #0083E6;
			}
			.v-text2 {
				color: #FFC044;
			}
			.v-text3 {
				color: #C88045;
			}
			.v-text4 {
				color: #ED234D;
			}
		}
		.tips-box {
			display: flex;
			flex-wrap: wrap;
			.tips-view {
				width: calc(100% / 3);
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 10px 0 5px;
				img {
					width: 25px;
					height: 25px;
				}
				.tips-text {
					font-size: 12px;
					color: #9E9E9E;
					line-height: 2;
				}
			}
		}
		.vip-more-btn {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 auto;
			border-radius: 20px;
			cursor: pointer;
			transition: all 0.3s ease;
			user-select: none;
			span {
				color: #000;
				font-size: 13px;
				font-weight: 500;
				margin-right: 6px;
			}
			i {
				color: #000;
				font-size: 12px;
				transition: transform 0.3s ease;
			}
		}
	}
	.vip-box {
		display: flex;
		align-items: center;
		padding: 0 20px;
		cursor: pointer;
		img {
			width: 50px;
			height: 50px;
		}
		.vip-name {
			border-radius: 5px 5px 5px 5px;
			text-shadow: 0px 1px 0px #5E5C63;
			color: #fff;
			line-height: 30px;
			width: 90px;
			text-align: center;
			margin: 0 10px;
		}
		.vip-name0 {
			background: linear-gradient( 133deg, #C9CBD0 0%, #ACACAF 45.87%, #84858F 100%);
			border-image: linear-gradient(180deg, rgba(245, 246, 251, 1), rgba(203, 209, 220, 1)) 1 1;
		}
		.vip-name1 {
			background: linear-gradient( 133deg, #D4E4FF 0%, #5DACE9 97.86%);
			border-image: linear-gradient(180deg, rgba(252, 252, 252, 1), rgba(225, 227, 232, 1)) 1 1;
		}
		.vip-name2 {
			background: linear-gradient( 133deg, #F1C32B 0%, #FCC13E 100%);;
			border-image: linear-gradient(180deg, rgba(246, 231, 192, 1), rgba(226, 199, 136, 1)) 1 1;
		}
		.vip-name3 {
			background: linear-gradient( 133deg, #FFDAAD 0%, #E4AE7E 45.87%, #C77E43 100%);
			border-image: linear-gradient(180deg, rgba(254, 215, 170, 1), rgba(222, 158, 104, 1)) 1 1;
		}
		.vip-name4 {
			background: linear-gradient( 133deg, #FB8499 0%, #DE485B 96.61%);
			border-image: linear-gradient(180deg, rgba(249, 161, 180, 1), rgba(235, 208, 209, 1)) 1 1;
		}
		.vip-vipPoints {
			color: #425077;
		}
	}
	.vip-tabs-container {
		padding: 20px 0;
	}
	.vip-level-tabs {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 30px;
		position: relative;
		padding-bottom: 20px;
		&::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 80%;
			height: 1px;
			background: #e8e8e8;
		}
	}
	.vip-tab-item {
		cursor: pointer;
		padding: 12px 24px;
		margin: 0 5px;
		text-align: center;
		transition: all 0.3s;
		position: relative;
		border-radius: 4px;
		.vip-tab-name {
			font-size: 16px;
			color: #666;
			font-weight: normal;
			transition: all 0.3s;
		}
	}
	.vip-tab-item.vip-tab-now {
		background: rgba(24, 144, 255, 0.05);
	}
	.vip-tab-item.vip-tab-active {
		background: rgba(24, 144, 255, 0.08);
		.vip-tab-name {
			color: #1890ff;
			font-weight: bold;
			font-size: 17px;
		}
		&::before {
			content: '';
			position: absolute;
			bottom: -20px;
			left: 50%;
			transform: translateX(-50%);
			width: 40px;
			height: 3px;
			background: #1890ff;
			border-radius: 2px;
			z-index: 1;
		}
	}
	.vip-tab-item.vip-tab-locked {
		opacity: 0.6;
		.vip-tab-name {
			color: #bbb;
			position: relative;
		}
	}
	.vip-lock-icon {
		margin-left: 4px;
		font-size: 12px;
		color: #bfbfbf;
		vertical-align: middle;
	}
	.vip-tab-item.vip-tab-locked.vip-tab-active {
		opacity: 0.8;
		.vip-tab-name {
			color: #8c8c8c;
		}
		.vip-lock-icon {
			color: #8c8c8c;
		}
	}
	.vip-content-wrapper {
		position: relative;
		display: flex;
		align-items: center;
		margin: 15px 0 10px;
		padding: 0 10px;
	}
	.vip-content-area {
		flex: 1;
		min-height: 380px;
		padding: 5px 0 15px;
		position: relative;
		overflow: hidden;
		cursor: grab;
		user-select: none;
		&:active {
			cursor: grabbing;
		}
	}
	.vip-slide-tip {
		text-align: center;
		padding: 25px 0 8px;
		color: #999;
		font-size: 12px;
		opacity: 0.7;
		position: relative;
		z-index: 2;
	}
	.vip-slide-hint {
		width: 36px;
		height: 36px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(24, 144, 255, 0.08);
		border: 1px solid rgba(24, 144, 255, 0.2);
		border-radius: 50%;
		color: #1890ff;
		font-size: 16px;
		animation: pulse 2s infinite;
		flex-shrink: 0;
		pointer-events: none;
	}
	@keyframes pulse {
		0%, 100% {
			opacity: 0.5;
			transform: scale(1);
		}
		50% {
			opacity: 0.9;
			transform: scale(1.05);
		}
	}
	.left-hint {
		margin-right: 8px;
	}
	.right-hint {
		margin-left: 8px;
	}
	.vip-slider-wrapper {
		display: flex;
		will-change: transform;
	}
	.vip-slider-item {
		min-width: 100%;
		flex-shrink: 0;
		padding: 0 15px;
		box-sizing: border-box;
		.vip-title {
			line-height: 40px;
			color: #000;
			text-align: center;
		}
	}
	.uplevel {
		background: linear-gradient(135deg, #fff7e6 0%, #ffecc7 50%, #fff5d9 100%);
		border-radius: 8px;
		padding: 12px 16px;
		margin: 0 auto;
		margin-bottom: 18px;
		text-align: center;
		font-size: 13px;
		color: #ad6800;
		line-height: 1.7;
		position: relative;
		box-shadow: 0 2px 10px rgba(250, 140, 22, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		width: 400px;
		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: -100%;
			width: 100%;
			height: 100%;
			background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
			animation: shine 3s infinite;
		}
	}
	@keyframes bounce {
		0%, 100% {
			transform: translateY(0);
		}
		50% {
			transform: translateY(-3px);
		}
	}
	@keyframes shine {
		0% {
			left: -100%;
		}
		100% {
			left: 100%;
		}
	}
	.vip-indicators {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 8px;
		padding: 12px 0 8px;
		margin-top: 5px;
	}
	.vip-indicator {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #d9d9d9;
		cursor: pointer;
		transition: all 0.3s ease;
		&:hover {
			background: #1890ff;
			transform: scale(1.3);
		}
	}
	.vip-indicator-active {
		width: 20px;
		height: 6px;
		border-radius: 3px;
		background: #1890ff;
	}
	.vip-locked-tip {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 60px 20px;
		min-height: 350px;
		color: #bfbfbf;
		i {
			font-size: 64px;
			margin-bottom: 20px;
			color: #d9d9d9;
			opacity: 0.6;
		}
		.locked-text {
			font-size: 16px;
			color: #8c8c8c;
			margin-bottom: 10px;
			font-weight: 500;
		}
		.locked-desc {
			font-size: 13px;
			color: #bfbfbf;
			text-align: center;
			line-height: 1.6;
		}
	}
</style>